import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { getTripStatusConfig } from '../../../common/enums/trip-status.enum';

@Component({
  selector: 'app-trip-status-icon',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  template: `
    <mat-icon
      [svgIcon]="iconName"
      [ngClass]="[bgClass, iconClass]"
      [class]="sizeClasses">
    </mat-icon>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TripStatusIconComponent {
  @Input() statusTripId!: number;
  @Input() size: 'sm' | 'md' | 'lg' = 'md';

  get iconName(): string {
    const config = getTripStatusConfig(this.statusTripId);
    return config?.icon ?? 'heroicons_solid:question-mark-circle';
  }

  get bgClass(): string {
    const config = getTripStatusConfig(this.statusTripId);
    return config?.filterBgClass ?? 'bg-gray-100';
  }

  get iconClass(): string {
    const config = getTripStatusConfig(this.statusTripId);
    return config?.filterIconClass ?? 'text-gray-800';
  }

  get sizeClasses(): string {
    const baseClasses = 'rounded-full inline-flex items-center justify-center';
    const sizeMap = {
      sm: 'h-5 w-5 p-1',
      md: 'h-6 w-6 p-1.5',
      lg: 'h-8 w-8 p-2'
    };
    return `${baseClasses} ${sizeMap[this.size]}`;
  }
}
